import { AuroraBackground } from '../componentes/aurora-background';
import { AuthCard } from '../componentes/entrar/auth-card';
import { BrandPanel } from '../componentes/entrar/brand-panel';
import { LoginForm } from '../componentes/entrar/login-form';

/**
 * Tela de login: fundo animado (`<AuroraBackground />`) atrás de um cartão
 * flutuante centralizado (`<AuthCard />`), marca à esquerda
 * (`<BrandPanel />`) e formulário à direita (`<LoginForm />`).
 *
 * Nenhuma regra de negócio mora aqui — `LoginForm` é quem chama
 * `useSessao().entrar` e trata `ErroApi`. Esta página só monta o layout.
 */
export function Entrar(): JSX.Element {
  return (
    <main className="relative grid min-h-screen place-items-center overflow-hidden p-4 sm:p-8">
      <AuroraBackground />
      <AuthCard>
        <BrandPanel />
        <LoginForm />
      </AuthCard>
    </main>
  );
}
